module.exports = __webpack_public_path__ + "static/img/icon-qcxj-large.59c567f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qcxj/icon-qcxj-large.png
// module id = 1029
// module chunks = 0